/**
 * StarRating
 *
 * Renders a row of star icons equal to the given count.
 * Replaces the '★'.repeat(stars) emoji pattern used across
 * CatchScreen, FishDetailOverlay, and InventoryView.
 *
 * Props:
 *   count {number} - How many stars to render.
 *   size  {number} - Icon size in px. Defaults to 12.
 */

import { starIcon } from '../constants/assets';

export default function StarRating({ count, size = 12 }) {
  return (
    <span style={{ display: 'inline-flex', gap: '2px' }}>
      {Array.from({ length: count }).map((_, i) => (
        <img
          key={i}
          src={starIcon}
          alt="star"
          style={{ width: `${size}px`, height: `${size}px`, imageRendering: 'pixelated' }}
        />
      ))}
    </span>
  );
}